import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import _ from 'lodash';
import { Input, Header, Segment, Checkbox, Message, Button, Form, Grid, Divider, Label } from 'semantic-ui-react';
import { withFormik } from 'formik';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { AuthClient, EnjoyIcon } from '@emyw/core-lib';
import { normalizeErrors } from '../utils';
import '../primitives.css';

// const { REACT_APP_AUTH_CLIENT_IMAGE_PATH } = process.env;

const Wrapper = elements => elements.children.map(element => element);
const ManageAccountLogic = withFormik({
  validateOnBlur: false,
  validateOnChange: false,
  // Transform outer props into form values
  mapPropsToValues: _ref => {
    let {
      user
    } = _ref;
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      pin: user.pin,
      passwordEnabled: false,
      password: '',
      passwordConfirm: ''
    };
  },
  // Add a custom validation function (this can be async too!)
  validate: values => {
    // , props
    const errors = {};
    // First Name
    if (!values.firstName) {
      errors.firstName = 'First name required';
    } else if (values.firstName.length < 2) {
      errors.firstName = 'First name must be at least 2 characters';
    }
    // Last Name
    if (!values.lastName) {
      errors.lastName = 'Last name required';
    } else if (values.lastName.length < 2) {
      errors.lastName = 'Last name must be at least 2 characters';
    }
    // Email (This gets handled in the update email form)
    // if (!values.email) {
    //     errors.email = 'Email required';
    // } else if (
    //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    // ) {
    //     errors.email = 'Invalid email address';
    // }
    // Password
    if (values.passwordEnabled && values.password.length < 5) {
      errors.password = 'Password must be at least 5 characters';
    }
    // Password Confirm
    if (values.passwordEnabled && values.passwordConfirm !== values.password) {
      errors.passwordConfirm = 'Passwords don\'t match';
    }
    return errors;
  },
  // Submission handler
  handleSubmit: async (values, _ref2) => {
    let {
      props: {
        mutate,
        user,
        onUpdate
      },
      setSubmitting,
      setErrors,
      setFieldValue,
      setValues
    } = _ref2;
    const userInput = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.passwordEnabled ? values.password : ''
    };
    try {
      const response = await mutate({
        variables: {
          userId: user.id,
          userInput
        }
      });
      const {
        ok,
        errors
      } = response.data.updateAccount;
      if (ok) {
        if (userInput.firstName !== user.firstName || userInput.lastName !== user.lastName || userInput.password) {
          if (onUpdate) onUpdate(values);else log.warn('onUpdate prop required but not provided');
        }
        setValues({
          ...values,
          password: '',
          passwordConfirm: ''
        });
        setFieldValue('passwordEnabled', false);
      } else {
        setErrors(normalizeErrors(errors));
      }
    } catch (error) {
      setErrors({
        unknown: [error.message]
      });
    }
    setSubmitting(false);
  }
});

/** Manage Account Form allows for maintenance of the user account.
 * <br /><br /><hr /><br />
 * <div>
 * <h4>Back-end Requirements</h4>
 * A backend graphql api endpoint with the updateAccount mutation,
 * <a rel=noopener href="https://github.com/emyw/auth-api">auth-api</a>,
 * is needed for this form to function.
 * <h4>Manage Account</h4>
 * This allows for updating of the basic account data for the user. Other profile type data
 * is expected to be managed by a client of this library as it is not helpful to be too
 * opinionated here as to what sorts of information may need to be collected.
 * </div>
 */
const ManageAccountForm = _ref3 => {
  let {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    onChangeEmail,
    onSetPin,
    isSubmitting,
    setFieldValue,
    touched,
    errors
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    color: "blue",
    attached: "top"
  }, /*#__PURE__*/React.createElement(EnjoyIcon, {
    className: "formTitleIcon"
  }), " \xA0 Manage Account"), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form, {
    className: "manageAccountForm"
  }, /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Field, {
    className: "readOnlyField",
    error: !!errors.email,
    width: "10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "readOnlyFieldValue"
  }, /*#__PURE__*/React.createElement("span", {
    className: "fieldLabel"
  }, /*#__PURE__*/React.createElement(Label, {
    content: "Email",
    icon: "mail"
  })), /*#__PURE__*/React.createElement("span", null, values.email))), /*#__PURE__*/React.createElement(Form.Button, {
    className: "updateButton",
    type: "button",
    disabled: isSubmitting,
    onClick: onChangeEmail,
    basic: true,
    color: "blue",
    width: "6",
    fluid: true
  }, "Change Email")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Field, {
    className: "readOnlyField",
    error: !!errors.pin,
    width: "10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "readOnlyFieldValue",
    style: {}
  }, /*#__PURE__*/React.createElement("span", {
    className: "fieldLabel"
  }, /*#__PURE__*/React.createElement(Label, {
    content: "PIN",
    icon: "keyboard outline"
  })), /*#__PURE__*/React.createElement("span", {
    className: values.pin ? '' : 'emptyFieldValue'
  }, values.pin ? '*'.repeat(values.pin.length) : 'No PIN set'))), /*#__PURE__*/React.createElement(Form.Button, {
    className: "updateButton",
    type: "button",
    disabled: isSubmitting,
    onClick: onSetPin,
    basic: true,
    color: "blue",
    width: "6",
    fluid: true
  }, "Set PIN"))), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.firstName
  }, /*#__PURE__*/React.createElement(Input, {
    name: "firstName",
    id: "firstName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.firstName,
    icon: "id card outline",
    iconPosition: "left",
    placeholder: "First Name",
    fluid: true,
    "data-lpignore": true
  })), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.lastName
  }, /*#__PURE__*/React.createElement(Input, {
    name: "lastName",
    id: "lastName",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.lastName,
    icon: "id card outline",
    iconPosition: "left",
    placeholder: "Last Name",
    fluid: true,
    "data-lpignore": true
  })), /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    attached: "top"
  }, "Update Password"), /*#__PURE__*/React.createElement(Segment, {
    attached: "bottom"
  }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    toggle: true,
    name: "passwordEnabled",
    id: "passwordEnabled",
    checked: values.passwordEnabled,
    onClick: (e, data) => {
      // e.preventDefault();
      setFieldValue(data.id, data.checked);
    },
    onKeyPress: e => {
      if (e.charCode === 32) {
        e.target.checked = !e.target.checked;
      }
    },
    label: "Click to Specify a new Password"
  })), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.password
  }, /*#__PURE__*/React.createElement(Input, {
    name: "password",
    id: "password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: !values.passwordEnabled ? '' : values.password,
    disabled: !values.passwordEnabled,
    icon: "lock",
    type: "password",
    iconPosition: "left",
    placeholder: "Password",
    fluid: true,
    "data-lpignore": true
  })), /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.passwordConfirm
  }, /*#__PURE__*/React.createElement(Input, {
    name: "passwordConfirm",
    id: "passwordConfirm",
    onChange: handleChange,
    onBlur: handleBlur,
    value: !values.passwordEnabled ? '' : values.passwordConfirm,
    disabled: !values.passwordEnabled,
    icon: "lock",
    type: "password",
    iconPosition: "left",
    placeholder: "Confirm Password",
    fluid: true,
    "data-lpignore": true
  }))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Grid, {
    columns: 2
  }, /*#__PURE__*/React.createElement(Grid.Row, {
    textAlign: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: "8"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    disabled: isSubmitting,
    onClick: handleReset,
    basic: true,
    color: "grey",
    fluid: true
  }, "Discard Changes")), /*#__PURE__*/React.createElement(Grid.Column, {
    width: "8"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: isSubmitting,
    onClick: handleSubmit,
    basic: true,
    color: "blue",
    fluid: true
  }, "Submit")))))), (touched.firstName && errors.firstName || touched.lastName && errors.lastName
  // || (touched.email && errors.email) // Email errors gets handled in the update email form
  || touched.password && errors.password || touched.passwordConfirm && errors.passwordConfirm || errors.unknown) && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Message, {
    size: "small",
    error: true,
    header: "Trouble with form...",
    list: _.concat(
    // errors.email,
    errors.firstName, errors.lastName, errors.password, errors.passwordConfirm, errors.unknown)
  })));
};
const updateAccountMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($userId: Int!, $userInput: UserInput!) {\n        updateAccount(userId: $userId, userInput: $userInput) {\n            ok\n            user {\n                id\n                email\n                firstName\n                lastName\n            }\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"])));
export default compose(graphql(updateAccountMutation, {
  client: AuthClient
}), ManageAccountLogic)(ManageAccountForm);